import { Injectable } from '@angular/core';
import { ReadonlyRepositoryImpl, ApiService } from '@eceos/arch';
import { Country } from './country';

@Injectable({providedIn:'root'})
export class CountriesRepository extends ReadonlyRepositoryImpl<Country, Country> {
  constructor(api: ApiService) {
    super(api.root.path('countries'), Country, Country);
  }
}
